import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
import { Content_ProviderMetadataFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderMetadataFragment.generated'
export type YiPose_ContentFragmentFragment = {
  __typename?: 'Content'
  contentPolicyPolicyId?: number | null
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  language?: string | null
  description?: string | null
  descriptionFormat?: string | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  path?: string | null
  primaryLanguage?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  seoDescription?: string | null
  seoTitle?: string | null
  title?: string | null
  titleGroupId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTags?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiPosePronunciation?: Array<{
    __typename?: 'ContentAssetReference'
    id?: string | null
    contentAssetReferenceTypesId?: string | null
    asset?: {
      __typename?: 'Asset'
      id?: string | null
      renderUrl?: string | null
      originalFileName?: string | null
      uuid?: string | null
    } | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export const YiPose_ContentFragmentFragmentDoc = gql`
  fragment YIPose_ContentFragment on Content {
    contentPolicyPolicyId
    id
    contentId
    contentType
    language
    description
    descriptionFormat
    shortDescription
    shortDescriptionFormat
    path
    primaryLanguage
    published
    publishedAtDate
    seoDescription
    seoTitle
    title
    titleGroupId
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiTags: contentReferencesFrom(types: "yi-tag") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiPosePronunciation: contentAssetReferences(
      contentAssetReferences: [{ type: "yi-pose-pronunciation" }]
    ) {
      id
      contentAssetReferenceTypesId
      asset {
        id
        renderUrl
        originalFileName
        uuid
      }
    }
    ...Content_ProviderMetadataFragment
  }
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
